export default __webpack_public_path__ + "static/media/03__o_preview_4.13a428e4.jpg";